import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { UserConfigComponent } from './components/user-config/user-config.component';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatCardModule } from '@angular/material/card';
import { ReactiveFormsModule } from '@angular/forms';
import { MatDialogModule } from '@angular/material/dialog';
import { UserProfileComponent } from './components/user-profile/user-profile.component';
import { LanguageModule } from '@app/shared/modules/language/language.module';
import { GooleCalendarConfigComponent } from './components/goole-calendar-config/goole-calendar-config.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { SubscriberModule } from '@app/shared/modules/subscriber/subscriber.module';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

const MaterialModules = [
  MatInputModule,
  MatButtonModule,
  MatSelectModule,
  MatRadioModule,
  MatCardModule,
  MatDialogModule,
  MatSlideToggleModule,
  MatProgressSpinnerModule,
];

@NgModule({
  declarations: [UserConfigComponent, UserProfileComponent, GooleCalendarConfigComponent],
  imports: [CommonModule, ReactiveFormsModule, MaterialModules, LanguageModule, SubscriberModule],
  exports: [UserConfigComponent, UserProfileComponent],
})
export class UserModule {}
